import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export interface WalletStatusChangedPayload {
  isActive: boolean;
}

export class WalletStatusChangedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(public readonly payload: WalletStatusChangedPayload) {
  }
}
